module.exports = __webpack_public_path__ + "img/5.55c94a28.png";